import React from 'react';
import { Spin } from 'antd';
import { useLocation } from 'react-router-dom';

import MicroApp from '../../components/MicroApp';
import useMicroServicesTools from '../../hooks/use-micro-services-tools';
import useMerchantSettings from '../../hooks/use-merchant-settings';

const innerContainerStyle = {
  display: 'flex',
  height: '100%',
  flex: 1,
};

const microAppStyle = {
  flex: 1,
};

const loadingContainerStyle = {
  ...innerContainerStyle,
  justifyContent: 'center',
  alignItems: 'center',
};

function Loading() {
  return (
    <div style={loadingContainerStyle}>
      <Spin />
    </div>
  );
}

export function ApplicationSettingsApp() {
  const location = useLocation();
  const fullPath = `${location.pathname}${location.search}`;
  const microServicesTools = useMicroServicesTools('settings');

  const { isLoading: isLoadingSettings, merchantSettings } =
    useMerchantSettings();

  if (isLoadingSettings) {
    return <Loading />;
  }

  return (
    <div style={innerContainerStyle}>
      <MicroApp
        name="application-settings"
        style={microAppStyle}
        loading={(<Loading />) as unknown as null}
        settings={merchantSettings}
        mountPath="/application-settings"
        pathAndQuery={fullPath}
        useHashHistory={false}
        {...microServicesTools}
      />
    </div>
  );
}
